export const NOTIFICATION_TYPES = {
  DIVIDEND_ANNOUNCEMENT: 'DIVIDEND_ANNOUNCEMENT',
  DIVIDEND_PAYMENT: 'DIVIDEND_PAYMENT',
  PORTFOLIO_VALUATION: 'PORTFOLIO_VALUATION',
};
